const userAgent = navigator.userAgent || navigator.vendor || window.opera;

/**
 * 是否ios端
 */
const isIOS = /ipad|iphone|ipod/i.test(userAgent);

var bridge = {
  postMessageToNative: function(requestType, method, data, cb) {
    var request = { method: method, type: requestType, data: data };
    if (typeof cb === "function") {
      var callbackId = `callback${window.callbackId++}`;
      window[callbackId] = cb;
      request["callback_id"] = callbackId;
    }

    try {
      var requestJson = JSON.stringify(request);
      if (isIOS && window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.we_bridge.postMessage(requestJson);
      } else {
        window.we_bridge.postMessageToNative(requestJson);
      }
    } catch (error) {
      console.log(error);
    }
  },
  callNativeMethod: function(method, data, cb) {
    this.postMessageToNative(1, method, data, cb);
  },
  addNativeListener: function() {},
  removeNativeListener: function() {},
};

(function() {
  if (window.weBridge) {
    return;
  }

  var ob = {
    callbackId: 0,
    weBridge: bridge,
    notifyMessage: function(message) {
      if (message && typeof message === "string") {
        try {
          message = JSON.parse(message);
          if (message) {
            const listener = window[message.type];
            if (listener && typeof listener === "function") {
              listener(message);
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
  };
  for (var attr in ob) {
    window[attr] = ob[attr];
  }
})();

export default bridge;
